import styled from 'styled-components';
import { FullWidthGridRow, GridRow, HeaderGridRow } from 'ui/indexPages/tables/grid';
import { body2, button, colors, spacing } from 'ui/theme';

/**
 * Rows
 */
export const StyledHeaderGridRow = styled(HeaderGridRow)`
  align-items: center;
  padding-right: ${spacing.plusHalf};
  padding-left: ${spacing.plusHalf};
`;

export const StyledGridRow = styled(GridRow)`
  align-items: center;
  padding-right: ${spacing.plusHalf};
  padding-left: ${spacing.plusHalf};

  &:last-child {
    border-radius: 0 0 ${spacing.half} ${spacing.half};
  }
`;

export const StyledFullWidthGridRow = styled(FullWidthGridRow)`
  padding-top: ${spacing.double};
  padding-bottom: ${spacing.double};
  text-align: center;
  color: ${colors.textSecondary};
  border-radius: 0 0 ${spacing.half} ${spacing.half};
`;

/**
 * Cells
 */
export const HeaderCell = styled.div`
  ${button}
  display: flex;
  align-items: center;
`;

export const BaseCell = styled.div`
  ${body2}
`;

export const CellActions = styled(BaseCell)`
  display: flex;
  gap: ${spacing.quarter};
`;
